// Absolute imports
import { NavLink } from 'react-router-dom'

// Helpers
import { links } from '../../helpers/linksList'

export const Sidebar = () => {
  return (
    <div className="z-2 fixed top-[calc(100vh_-38px)] z-10 flex w-full items-end justify-evenly gap-5 border-t border-gray-300 bg-white px-3 pt-2 sm:top-[80px] sm:z-0 sm:h-[calc(100vh_-89px)] sm:w-[100px] sm:flex-col sm:items-center sm:justify-start sm:border-r sm:border-t-0 sm:pt-[27px]">
      {links.map((link, index) => (
        <NavLink
          key={index}
          to={link.to}
          className={({ isActive }) =>
            `flex h-[30px] w-[30px] flex-col items-center sm:h-auto sm:w-[50px] sm:gap-1 ${isActive ? 'font-bold text-blue-500 fill-blue-500' : ''}`
          }
        >
          {link.icon}
          <p className="text-[10px] sm:text-[14px]">{link.text}</p>
        </NavLink>
      ))}
    </div>
  )
}
